import React, { useState } from "react";
import classNames from "classnames/bind";

import { useStateManager } from "utils/useStateManager";
import { Button } from "../Button";

import styles from "./FrequencyList.module.css";

const cx = classNames.bind(styles);

type Props = {
  items: {
    key: string;
    custom_частота: string;
  }[];
  onSubmit: () => void;
  onChange: (key: string) => void;
  activeKey?: string;
};

export const FrequencyList = React.forwardRef<HTMLDivElement, Props>(
  ({ items, onSubmit, onChange, activeKey }, ref) => {
    const { isLoading } = useStateManager();
    const [isSkipStepLoading, setSkipStepLoading] = useState<boolean>(false);

    // useEffect(() => {
    //     if (disabledButtons) {
    //         setTimeout(() => {
    //             setDisabledButtons(false)
    //         }, 4000)
    //     }
    // }, [disabledButtons])

    return (
      <div className={cx("container")} ref={ref}>
        <div
          className={cx("actions")}
          style={
            {
              "--items-count": items.length + 1,
            } as any
          }
        >
          <Button
            color="dark"
            type="button"
            size="medium"
            onClick={() => {
              setSkipStepLoading(true);
              setTimeout(() => {
                setSkipStepLoading(false);
                onSubmit();
                window.scrollTo(0, 0);
              }, 500);
            }}
            isLoading={isSkipStepLoading || isLoading}
            disabled={isSkipStepLoading || isLoading}
          >
            Никогда/очень редко
          </Button>
          {items.map((frequency) => (
            <Button
              key={frequency.key}
              color={activeKey === frequency.key ? "cerulean" : "dark"}
              type="button"
              size="medium"
              onClick={() => onChange(frequency.key)}
              disabled={isSkipStepLoading || isLoading}
            >
              {frequency.custom_частота}
            </Button>
          ))}
        </div>
      </div>
    );
  }
);
